import {
    AuthStatusBadge,
    UserMenu,
    GuestOnly,
    ProtectedRoute,
    RoleGate,
} from '@vendidit/auth-client/preact/ui/atoms';
import { demoConfig } from '../auth-client-config.js';

/**
 * Site header. Sticky-top with a subtle backdrop blur.
 *
 * Left: brand + env pill (so the user always knows which API the
 * demo is pointed at). When signed in, contextual nav links appear —
 * "Catalog", "Profile", and "Admin" (admin only) — letting the user
 * jump around the live-auth surfaces.
 *
 * Right:
 *   - AuthStatusBadge always
 *   - <GuestOnly> renders "Sign in" / "Create account" links
 *   - <ProtectedRoute> renders <UserMenu> with a "Profile" entry
 *
 * The header itself is composed entirely of SDK atoms — it's the
 * demo eating its own dogfood.
 */
export function Header() {
    const apiHost = (() => {
        try { return new URL(demoConfig.apiBaseUrl).host; }
        catch { return demoConfig.apiBaseUrl; }
    })();
    return (
        <header class="demo-header">
            <div class="demo-header-left">
                <div class="demo-header-brand">
                    <a href="/">@vendidit/auth-client</a>
                    <span style={{ color: 'var(--color-text-dim)', marginLeft: 'var(--space-2)' }}>demo</span>
                </div>
                <span class="demo-header-pill" title={`Backing auth-server: ${demoConfig.apiBaseUrl}`}>
                    → {apiHost}
                </span>
                <ProtectedRoute fallback={null}>
                    <nav class="demo-header-nav">
                        <a href="/">Catalog</a>
                        <a href="/profile">Profile</a>
                        <RoleGate anyOf={['system_admin', 'super_admin']} fallback={null}>
                            <a href="/admin/users">Users</a>
                            <RoleGate anyOf={['system_admin']} fallback={null}>
                                <a href="/admin/organizations">Organizations</a>
                                <a href="/admin/applications">Applications &amp; Services</a>
                            </RoleGate>
                            <a href="/admin/audit-log">Audit log</a>
                        </RoleGate>
                    </nav>
                </ProtectedRoute>
            </div>
            <div class="demo-header-right">
                <AuthStatusBadge />
                <GuestOnly fallback={null}>
                    <a href="/login" class="vauth-btn vauth-btn-ghost vauth-btn-sm">Sign in</a>
                    <a href="/register" class="vauth-btn vauth-btn-primary vauth-btn-sm">Create account</a>
                </GuestOnly>
                <ProtectedRoute fallback={null}>
                    <UserMenu
                        extra={<a href="/profile" class="vauth-btn vauth-btn-ghost vauth-btn-sm vauth-menu-link">Profile</a>}
                    />
                </ProtectedRoute>
            </div>
        </header>
    );
}
